import { useEffect, useState } from "react"

type Props = {
  callback?: () => void
}

function useStandalone({ callback }: Props) {
  const [isStandalone, setIsStandalone] = useState(false)
  useEffect(() => {
    const navigator: any = window?.navigator
    if (navigator?.standalone) {
      setIsStandalone(true)
      callback?.()
    }
  }, [])
  return { isStandalone }
}

export default useStandalone
